<template>
  <section>
    <div class="modal-body">
      <form class="m-form m-form--state" action="">
        <div class="form-group m-form__group">
          <div class="col-lg-12" :class="{'has-danger': errors.has('current_password')}">
            <label>{{ 'current_password' | capitalize }}</label>
            <input v-model="password.current_password" v-validate="'required|min:4|unique'" class="form-control m-input m-login__form-input--last" id="current_password" type="password" :placeholder="'current_password' | capitalize" name="current_password">
            <span v-show="errors.has('current_password')" class="m-form__help m--font-danger">{{ errors.first('current_password') }}</span>
          </div>
        </div>
        <div class="form-group m-form__group">
          <div class="col-lg-12" :class="{'has-danger': errors.has('password')}">
            <label>{{ 'password' | capitalize }}</label>
            <input v-model="password.new_password" v-validate="'required|min:4|confirmed:password|notEqual'"  class="form-control m-input m-login__form-input--last" id="password" type="password" :placeholder="'password' | capitalize" name="password">
            <span v-show="errors.has('password')" class="m-form__help m--font-danger">{{ errors.first('password') }}</span>
          </div>
        </div>
        <div class="form-group m-form__group">
          <div class="col-lg-12" :class="{'has-danger': errors.has('confirm_password')}">
            <label>{{ 'confirm_password' | capitalize }}</label>
            <input v-model="password.confirm_password" v-validate="'required|min:4|confirmed:password|notEqual'" :class="{'input': true, 'danger': errors.has('confirm_password') }" class="form-control m-input m-login__form-input--last" id="confirm_password" type="password" :placeholder="'confirm_password' | capitalize" name="confirm_password">
            <span v-show="errors.has('confirm_password')" class="m-form__help m--font-danger">{{ errors.first('confirm_password') }}</span>
          </div>
        </div>
      </form>
    </div>
    <div class="modal-footer">
      <button type="button" class="btn btn-secondary" data-dismiss="modal" @click="resetForm" id="btn-cancel">
        {{ 'cancel' | capitalize }}
      </button>
      <button type="button" class="btn btn-primary" @click="changePassword">
        {{ 'change' | capitalize }}
      </button>
    </div>
  </section>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { Validator } from 'vee-validate'
import axios from 'axios'
export default {
  data () {
    return {
      password: {
        id_user: '',
        current_password: '',
        new_password: '',
        confirm_password: ''
      }
    }
  },
  created () {
    this.password.id_user = this.getUserData.id
    this.isUnique()
    this.notEqual()
  },
  props: {
    title: { type: String, required: false },
    subTitle: { type: String, required: false },
    formPassword: { type: String, required: false }
  },
  methods: {
    changePassword () {
      this.$validator.validateAll()
        .then((result) => {
          if (result) {
            this.$confirmation()
              .then((res) => {
                this.$spinner.show()
                this.patchChangePassword(this.password)
                  .then((response) => {
                    if (response.status === 200) {
                      this.$spinner.remove()
                      this.$toast('password_updated')
                      document.getElementById('btn-cancel').click()
                    } else {
                      this.$spinner.remove()
                    }
                  })
                  .catch((err) => {
                    console.log(err)
                    this.$spinner.remove()
                  })
              })
              .catch((err) => {
                console.log(err)
              })
          }
        }, error => {
          console.log(error)
        })
    },
    resetForm () {
      this.changeModalStatus(false)
      Object.assign(this.$data, this.$options.data.call(this))
      setTimeout(() => {
        this.$validator.reset()
        this.password.id_user = this.getUserData.id
      }, 300)
    },
    ...mapActions(['changeModalStatus', 'patchChangePassword']),

    notEqual () {
      const notEqual = (value) => {
        let isValid = true
        if (this.password.current_password === value) {
          isValid = false
        }
        return {
          valid: isValid,
          data: {
            message: this.$options.filters.capitalize('password_not_equal_message')
          }
        }
      }

      Validator.extend('notEqual', {
        validate: notEqual,
        getMessage: (field, params, data) => {
          return data.message
        }
      })
    },

    isUnique () {
      const isUnique = (value) => {
        return axios.post('/api/user/check-password', { password: value, id: this.getUserData.id })
          .then((response) => {
            return {
              valid: response.data.valid,
              data: {
                message: this.$options.filters.capitalize('wrong_password')
              }
            }
          })
      }

      Validator.extend('unique', {
        validate: isUnique,
        getMessage: (field, params, data) => {
          return data.message
        }
      })
    }
  },
  computed: {
    ...mapGetters(['getUserData'])
  }
}
</script>



// WEBPACK FOOTER //
// FormPassword.vue